import React from 'react';
import { Form } from 'src/components/RcForm';

const ChangesMonitor = (props) => {
  const {
    setHasModified,
    pcForm,
    tabletForm,
    mobileForm,
    seoForm,
    loaded,
    orderForm,
    pageSettingForm,
    translationEnable,
  } = props;
  const pD = Form.useWatch([], pcForm);
  const tD = Form.useWatch([], tabletForm);
  const mD = Form.useWatch([], mobileForm);
  const sD = Form.useWatch([], seoForm);
  const oD = Form.useWatch([], orderForm);
  const paD = Form.useWatch([], pageSettingForm);
  React.useEffect(() => {
    if (!translationEnable && setHasModified && loaded) {
      setHasModified(true);
    }
  }, [pD, tD, mD, sD, oD, paD]);
  return <React.Fragment />;
};
export default ChangesMonitor;
